__turbopack_context__.v({
  "className": "crimson_pro_5ca9c8e2-module__4JWIdG__className",
  "variable": "crimson_pro_5ca9c8e2-module__4JWIdG__variable",
});
